import request from '../utils/request';

function getSchedules(params: {}) {
  return request({
    url: 'report/reportSchedules',
    method: 'get',
    params,
    headers: {
      'x-org-id': 'all',
    },
  });
}

function getReports(params: {}) {
  return request({
    url: 'report/reportHistory',
    method: 'get',
    params,
    headers: {
      'x-org-id': 'all',
    },
  });
}

function createReport(params: {}) {
  return request({
    url: 'report/reportHistory',
    method: 'post',
    data: params,
    headers: {
      'x-org-id': 'all',
    },
  });
}

function createSchedule(params: {}) {
  return request({
    url: 'report/reportSchedules',
    method: 'post',
    data: params,
    headers: {
      'x-org-id': 'all',
    },
  });
}

function updateSchedule(id: string, params: {}) {
  return request({
    url: `report/reportSchedules/${id}`,
    method: 'put',
    data: params,
    headers: {
      'x-org-id': 'all',
    },
  });
}

function getScheduleDetail(id: string, params = {}) {
  return request({
    url: `report/reportSchedules/${id}`,
    method: 'get',
    params,
    headers: {
      'x-org-id': 'all',
    },
  });
}

function delReports(reportFrom: string, ids: string[]) {
  return request({
    url: `report/reportHistory`,
    method: 'delete',
    data: {
      reportFrom,
      ids,
    },
    headers: {
      'x-org-id': 'all',
    },
  });
}

function delSchedules(reportFrom: string, ids: string[], names: string[]) {
  return request({
    url: `report/reportSchedules`,
    method: 'delete',
    data: {
      reportFrom,
      ids,
      names,
    },
    headers: {
      'x-org-id': 'all',
    },
  });
}

function switchScheduleStatus(id: string, enabled: boolean) {
  return request({
    url: `report/reportSchedules/${id}/status`,
    method: 'put',
    data: {
      enabled,
    },
    headers: {
      'x-org-id': 'all',
    },
  });
}

function downloadReport(id: string, reportFrom: string) {
  return request({
    url: `report/reportHistory/${id}/downloadLink?reportFrom=${reportFrom}`,
    method: 'get',
    responseType: 'arraybuffer',
    //responseType: 'blob',
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
    timeout: 120000,
    headers: {
      'x-org-id': 'all',
    },
  });
}

function getDefaultSetting() {
  return request({
    url: 'report/companies/reportGroupSetting',
    method: 'get',
    headers: {
      'x-org-id': 'all',
    },
  });
}

function saveDefaultSetting(params = {}) {
  return request({
    url: 'report/companies/reportGroupSetting',
    method: 'put',
    data: params,
    headers: {
      'x-org-id': 'all',
    },
  });
}

function saveLogo(file: any) {
  const data = new FormData();
  data.append('file', file);
  return request({
    url: `report/storage/logo`,
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data',
      'x-org-id': 'all',
    },
  });
}

function getLogo(storageId: string) {
  return request({
    url: `report/storage/logo/${storageId}`,
    method: 'get',
    headers: {
      'x-org-id': 'all',
    },
  });
}

export default {
  getSchedules,
  getReports,
  createReport,
  createSchedule,
  updateSchedule,
  getScheduleDetail,
  delReports,
  delSchedules,
  switchScheduleStatus,
  downloadReport,
  getDefaultSetting,
  saveDefaultSetting,
  saveLogo,
  getLogo,
};
